import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MaintenanceService {
  // tslint:disable-next-line:variable-name
  private _maintenance$ = new BehaviorSubject<boolean>(false);
  maintenance$ = this._maintenance$.asObservable();

  enable() {
    this._maintenance$.next(true);
  }

  disable() {
    this._maintenance$.next(false);
  }
}
